import restFactory from 'v2/utils/restFactory';

export async function deleteActivity(id: number) {
  return await restFactory.delete<undefined>(`/dj/api/v1/activity/${id}/`);
}
